// extracted by mini-css-extract-plugin
export default {"link":"CRXHmh","root":"S7cd3Q","label":"SATQZb"};